import React, {useEffect} from "react";
import bgImg from '../Images/treatments.webp'
import Breadcrumb from "../Components/Breadcrumb";
import TreatmentGrid from "../Components/TreatmentGrid";
import Testimonials from "../Components/Testimonials";
import Cta from "../Components/Cta";
import { treatmentsGandhidham } from "../Data";
import BreadcrumbSchema from "../Schema/BreadcrumbSchema";
import TreatmentsCollectionSchema from "../Schema/TreatmentsCollectionSchema";

const TreatmentsCommonGandhidham=()=>{

useEffect(() => {
        document.title =
          "Ayurvedic Treatment in Gandhidham, Kutch | Dr. Jigar Gor";
    
        const metaDesc = document.querySelector("meta[name='description']");
        if (metaDesc) {
          metaDesc.setAttribute(
            "content",
            "Explore Ayurvedic treatments in Gandhidham, Kutch with Dr. Jigar Gor at a trusted Ayurvedic clinic, offering personalized care for holistic wellness."
          );
        }
    
        const canonical = document.querySelector("link[rel='canonical']");
      if (canonical) {
        canonical.setAttribute("href", "https://msayurved.com/treatments/gandhidham");
      }
    
      const ogTitle = document.querySelector("meta[property='og:title']");
      if (ogTitle) {
        ogTitle.setAttribute(
          "content",
          "Ayurvedic Treatment in Gandhidham, Kutch | Dr. Jigar Gor"
        );
      }
    
        const ogDesc = document.querySelector("meta[property='og:description']");
      if (ogDesc) {
        ogDesc.setAttribute(
          "content",
          "Explore Ayurvedic treatments in Gandhidham, Kutch with Dr. Jigar Gor at a trusted Ayurvedic clinic, offering personalized care for holistic wellness."
        );
      }
    
      const ogUrl = document.querySelector("meta[property='og:url']");
      if (ogUrl) {
        ogUrl.setAttribute("content", "https://msayurved.com/treatments/gandhidham");
      }
    
        const ogImage = document.querySelector("meta[property='og:image']");
      if (ogImage) {
        ogImage.setAttribute(
          "content",
          "https://msayurved.com/Images/treatments.webp"
        );
      }
    
        const twitterTitle = document.querySelector("meta[name='twitter:title']");
      if (twitterTitle) {
        twitterTitle.setAttribute(
          "content",
          "Ayurvedic Treatment in Gandhidham, Kutch | Dr. Jigar Gor"
        );
      }
    
        const twitterDesc = document.querySelector(
        "meta[name='twitter:description']"
      );
      if (twitterDesc) {
        twitterDesc.setAttribute(
          "content",
          "Explore Ayurvedic treatments in Gandhidham, Kutch with Dr. Jigar Gor at a trusted Ayurvedic clinic, offering personalized care for holistic wellness."
        );
      }
    
        const twitterImage = document.querySelector("meta[name='twitter:image']");
      if (twitterImage) {
        twitterImage.setAttribute(
          "content",
          "https://msayurved.com/Images/treatments.webp"
        );
      }
      }, []);

const breadcrumbItems = [
    {
      name: "Home",
      url: "https://msayurved.com/"
    },
    {
      name: "Treatments provided by Dr. Jigar Gor in Gandhidham",
      url: "https://msayurved.com/treatments/gandhidham"
    },
  ];

    return(
        <>
        <BreadcrumbSchema items={breadcrumbItems} />
        <TreatmentsCollectionSchema treatments={treatmentsGandhidham} />

         {/**BREADCRUMB SECTION */}
        <Breadcrumb
        title="Ayurvedic Treatments in Gandhidham"
        bgImage={bgImg}
        />

        {/**TREATMENTS GRID */}
        <TreatmentGrid 
        heading="Authentic Ayurvedic Treatments in Gandhidham, Kutch"
        basePath="/treatments/gandhidham"
        />

        <div style={{marginBottom:"80px"}}></div>

        {/**TESTIMONIALS */}
        <Testimonials />

        <div style={{marginBottom:"-80px"}}></div>

        {/**CTA*/}
        <Cta 
        heading="Start Your Ayurvedic Treatment Journey in Gandhidham"
        desc="Take the first step towards personalized Ayurvedic wellness with Dr. Jigar Gor in Gandhidham, Kutch. Get personalized Ayurvedic care for specific health concerns or overall well-being. Explore our specialized treatments and connect with us to begin your journey towards holistic health and natural wellness."
        />
        </>
    )
}
export default TreatmentsCommonGandhidham;